<template>
<div>
  <v-container fluid class="align-center px-5">
    <v-card flat class="intro-body align-center justify-center pt-0" :class="cardClass()">
      <div v-if="embedded" class="geo-location-icon" aria-hidden="true">
        <v-icon size="36" color="var(--accent-teal)">
          {{ locationPermissionIcon }}
        </v-icon>
      </div>
      <v-card-text class="py-1 px-0 overflow-auto">
        <mrx-translation class="white--text mb-4" token="questions.geo_permission.message"></mrx-translation>
        <v-btn block x-large class="mb-4 px-0" @click="askForGeo()" :id="'ask-for-geo'" >
          <v-progress-circular v-if="loading" indeterminate color="white" size=30 class="me-2"></v-progress-circular>
          <v-icon v-if="finished" size=30 :color="this.iconBackground" left>{{icon}}</v-icon>
          <mrx-translation :renderAsHTML="true" :token="buttonToken"></mrx-translation>
        </v-btn>
        <mrx-translation class="white--text pb-4" :token="finishMessage"></mrx-translation>
      </v-card-text>
    </v-card>
  </v-container>
</div>
</template>

<script>
  import languageLogic from '@/mixins/languageLogic'
  import icons from '@/mixins/icons'
  import ui from '@/mixins/ui'
  import { mdiMapMarkerOutline } from '@mdi/js'
  import { useGeoStore } from '@/stores/geo';
  import { mapActions } from 'pinia'

  export default {
    mixins: [languageLogic, icons, ui],
    name: 'geolocation',
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        locationPermissionIcon: mdiMapMarkerOutline,
        stepper: 1,
        geoError: true,
        icon: null,
        iconText: 'responses.geo_permission.message.searching.title',
        iconBackground: 'grey',
        iconColor: 'white',
        finished: false,
        loading: false,
        finishMessage: ''
      }
    },

    props: {
      items: Array,
      options: Object,
      languagePath: String,
      panelName: String,
      embedded: Boolean
    },

    watch: {
      items: {
        immediate: true,
        handler: 'syncStoredResult',
      },
      panelName: 'syncStoredResult',
    },
    methods: {
      ...mapActions(useGeoStore, ['getPosition']),
      syncStoredResult() {
        if (!this.embedded) return

        const response = this.items?.[0]
        const granted = response?.value === 'granted'
        this.finished = Boolean(response?.selected && (granted || response.value === 'denied'))
        this.icon = this.finished
          ? (granted ? this.icons.mdiCheckCircle : this.icons.mdiAlertCircle)
          : null
        this.iconBackground = this.finished ? (granted ? 'success' : 'danger') : 'grey'
        this.iconText = this.finished
          ? `responses.geo_permission.message.${response.value}.title`
          : 'responses.geo_permission.message.searching.title'
        this.finishMessage = this.finished && !granted
          ? 'responses.geo_permission.message.error.instructions'
          : ''
      },
      async askForGeo() {
        // do not repeat check if already complete
        if (this.finished) {
          return
        }

        this.loading = true
        this.geoError = true
        this.stepper = 2
        let positionFetchSuccess = await this.getPosition()

        if (positionFetchSuccess) {
          this.icon = this.icons.mdiCheckCircle
          this.iconBackground = 'success'
          this.items[0].value = 'granted'
          this.items[0].selected = true
          this.$track(this.$analyticsEvents.GEOLOCATION_GRANTED, {
            component: 'GeoLocation',
            panel_name: this.panelName
          })
        }
        else {
          this.icon = this.icons.mdiAlertCircle
          this.finishMessage = `responses.geo_permission.message.error.instructions`
          this.iconBackground = 'danger'
          this.items[0].value = 'denied'
          this.items[0].selected = true
          this.$track(this.$analyticsEvents.GEOLOCATION_DENIED, {
            component: 'GeoLocation',
            panel_name: this.panelName
          })
        }
        this.finished = true
        this.loading = false
        this.iconText = `responses.geo_permission.message.${this.items[0].value}.title`
      }
    },
    computed: {
      buttonToken() {
        if (this.finished || this.loading) {
          return this.iconText
        } else {
          return `questions.geo_permission.grant_access`
        }
      }
    }
  }
</script>

<style src="./styles/geo-location.css" scoped></style>
